/*
 * @Author: Teemo Ding
 * @Date: 2021-07-09 11:27:52
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 15:27:56
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Taxes/TaxListPage/config.tsx
 */
import React from 'react';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { Type } from 'src/constrains/ProductsSelection/ProductSelectionWithHsCode';
import { calculateCountryAreasText, formatNumber } from 'src/tools/helper';
import css from './css.module.less';

const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('storeTaxes.taxListPage.tax'),
  },
];

const applyToList = (productCount) => {
  return {
    [Type.Shipping]: 'Shipping Rate',
    [Type.All]: 'All Products',
    [Type.Order]: 'Order',
    [Type.HSCode]: productCount + ' Products',
    [Type.Specific]: productCount + ' Products',
  };
};
const columns = (
  deleteFun,
  editFun,
  countrys,
  disableView,
  disableDelete,
  { getI18n },
) => [
  {
    title: getI18n('storeTaxes.taxListPage.taxRuleTitle'),
    dataIndex: 'ruleTitle',
    key: 'ruleTitle',
    default: true,
    optional: false,
    sorter: true,
    className: css.columnClass,
    minWidth: 236,
  },
  {
    title: getI18n('storeTaxes.taxListPage.taxAppliesto'),
    dataIndex: 'products',
    default: true,
    optional: true,
    key: 'products',
    className: css.columnClass,
    minWidth: 148,
    childGenerate: (tags, record) =>
      applyToList(record.productCount)[record.applyTo],
  },
  {
    title: getI18n('storeTaxes.taxListPage.taxCountryArea'),
    dataIndex: 'countryAreas',
    default: true,
    optional: true,
    key: 'countryAreas',
    className: css.columnClass,
    minWidth: 229,
    childGenerate: (countryAreas, record) => {
      return (
        <NoWrapContainer>
          <Tooltip
            overlayClassName={css.overlayClassName}
            title={countryAreas
              .map(
                (item) =>
                  `${item?.country?.name} ${calculateCountryAreasText(
                    item,
                    countrys,
                  )}`,
              )
              .join(',')}>
            {countryAreas
              .map(
                (item) =>
                  `${item?.country?.name} ${calculateCountryAreasText(
                    item,
                    countrys,
                  )}`,
              )
              .join(',')}
          </Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n('storeTaxes.taxListPage.condition'),
    dataIndex: 'condition',
    default: true,
    optional: true,
    key: 'condition',
    className: css.columnClass,
    minWidth: 185,
    childGenerate: (tags, record) => {
      if (!record.conditionsApplied) {
        return 'N/A';
      } else if (record.conditions.maximum === null) {
        return `${formatNumber(record.conditions.minimum)}${
          record.rateCurrency || record.conditions.chargeCurrency
        } ${getI18n('storeTaxes.taxListPage.andup')}`;
      } else {
        return `${formatNumber(record.conditions.minimum)}${
          record.rateCurrency || record.conditions.chargeCurrency
        } - ${formatNumber(record.conditions.maximum)}${
          record.rateCurrency || record.conditions.chargeCurrency
        }`;
      }
    },
  },
  {
    title: getI18n('storeTaxes.taxListPage.compound'),
    dataIndex: 'compound',
    default: true,
    optional: true,
    key: 'compound',
    className: css.columnClass,
    minWidth: 148,
    childGenerate: (text, record) =>
      text ? getI18n('general.yes') : getI18n('general.no'),
  },
  {
    title: getI18n('storeTaxes.taxListPage.taxRate'),
    dataIndex: 'taxRate',
    default: true,
    optional: true,
    key: 'taxRate',
    className: css.columnClass,
    minWidth: 148,
    childGenerate: (tags, record) =>
      `${record.rateCurrency ? formatNumber(record.taxRate) : record.taxRate} ${
        record.rateCurrency || '%'
      }`,
  },
  {
    title: getI18n('general.linkModule.Modal.action'),
    dataIndex: 'action',
    default: true,
    optional: true,
    key: 'action',
    className: css.columnClass,
    minWidth: 139,
    childGenerate: (tags, record) => (
      <div className={css.actionClass}>
        {disableDelete ? (
          '-'
        ) : (
          <span className={css.delete} onClick={() => deleteFun(record)}>
            {getI18n('general.delete')}
          </span>
        )}
        {disableView ? (
          '-'
        ) : (
          <span className={css.edit} onClick={() => editFun(record)}>
            {getI18n('general.edit')}
          </span>
        )}
      </div>
    ),
  },
];

// const caculateText = (record, countrys) => {
//   const length = (
//     countrys.filter(
//       (country) => country.country.code === record.country.code,
//     )[0]?.subdivisions || []
//   ).length;
//   const { subdivisions = [] } = record;
//   const sub =
//     subdivisions && length !== (subdivisions || []).length
//       ? `(${(subdivisions || []).length} of ${length} province:${(
//           subdivisions || []
//         )
//           .map((item) => item.name)
//           .join(',')})`
//       : '';
//   return sub;
// };
export { breadcrumbData, columns };
